import script from "./ImageModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageModal.vue?vue&type=script&setup=true&lang=ts"

import "./ImageModal.vue?vue&type=style&index=0&id=98db9d54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98db9d54"]])

export default __exports__